import { useEffect, useState } from "react";
import { fetchInsight, fetchInsights } from "./insightsService";

const useRequest = (load, dependencies) => {
  const [result, setResult] = useState({ state: "loading", data: null, error: null });
  useEffect(() => {
    const controller = new AbortController();
    setResult({ state: "loading", data: null, error: null });
    load(controller.signal)
      .then((data) => setResult({ state: "success", data, error: null }))
      .catch((error) => {
        if (error.name !== "AbortError") setResult({ state: error.status === 404 ? "not-found" : "error", data: null, error });
      });
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
  return result;
};

export const useInsights = () => useRequest((signal) => fetchInsights(signal), []);
export const useInsight = (slug) => useRequest((signal) => fetchInsight(slug, signal), [slug]);
